module.exports = __webpack_public_path__ + "assets/img/1-5.2f160694.png";